/**
 * Shared bio payloads for Aracely Garcia (Team Leader) + Amy Farris
 * (Fitness Director).
 *
 * These are consumed by:
 *   - components/HeroDemoStrip.jsx (the LEFT_HOSTS crossfade card)
 *   - components/Hero.jsx           (the TeamStage Aracely + Amy hero cards)
 *
 * Single source of truth so the displayed bio in both places stays in sync.
 */
import { trainers } from '../mock';

export const ARACELY_URL = '/img/aracely-2026-07.webp';

export const ARACELY_BIO = {
  src: ARACELY_URL,
  first: 'ARACELY',
  last: 'GARCIA',
  badge: '★ TEAM LEADER',
  role: 'Team Leader',
  summary:
    'Team Leader and member-experience champion — the face who knows every regular by name and keeps the floor humming.',
  bio:
    "Aracely runs the day-to-day energy of the FitnessPro floor — onboarding new members, coordinating the team, and making sure everyone from a first-timer to a 34-year regular feels at home. If you have a question about classes, the kid-care room, or just want a fist bump on the way in, she's your person.",
  phone: '(209) 745-5382',
  email: 'aracely@fitnessprogalt.com',
  instagram: null,
  location: 'GALT · CA',
};

const AMY_TRAINER = trainers.find((t) => t.name === 'Amy Farris');
export const AMY_URL = AMY_TRAINER ? AMY_TRAINER.image : null;
export const AMY_BIO = AMY_TRAINER && {
  src: AMY_TRAINER.image,
  first: AMY_TRAINER.first,
  last: AMY_TRAINER.last,
  badge: '★ DIRECTOR',
  role: AMY_TRAINER.role,
  summary: AMY_TRAINER.summary,
  bio: AMY_TRAINER.bio,
  phone: AMY_TRAINER.phone,
  email: AMY_TRAINER.email,
  instagram: AMY_TRAINER.instagram,
  location: 'GALT · CA',
};
